(function () {
  'use strict';

  // ─── Config ───────────────────────────────────────────────────────────────
  // "Almost there" kicks in when the customer is 60%+ of the way to threshold.
  var ALMOST_THRESHOLD_PERCENT = 0.6;

  // ─── Format pence to £X or £X.XX ─────────────────────────────────────────
  function formatMoney(pence) {
    var pounds = pence / 100;
    if (pounds % 1 === 0) {
      return '£' + pounds;
    }
    return '£' + pounds.toFixed(2);
  }

  // ─── State copy ───────────────────────────────────────────────────────────
  function getStateCopy(total, threshold) {
    var remaining = threshold - total;
    var percent = total / threshold;
    var remainingFormatted = formatMoney(remaining);

    if (total === 0) {
      // State 1: empty basket
      return {
        state: 'default',
        html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free 7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M96 144C87.2 144 80 151.2 80 160L80 448C80 456.8 87.2 464 96 464L99.3 464C109.7 427.1 143.7 400 184 400C224.3 400 258.2 427.1 268.7 464L371.3 464C376.2 446.6 386.4 431.3 400 420.1L400 160C400 151.2 392.8 144 384 144L96 144zM99.3 512L96 512C60.7 512 32 483.3 32 448L32 160C32 124.7 60.7 96 96 96L384 96C419.3 96 448 124.7 448 160L448 192L503.4 192C520.4 192 536.7 198.7 548.7 210.7L589.3 251.3C601.3 263.3 608 279.6 608 296.6L608 448C608 483.3 579.3 512 544 512L540.7 512C530.3 548.9 496.3 576 456 576C415.7 576 381.8 548.9 371.3 512L268.7 512C258.3 548.9 224.3 576 184 576C143.7 576 109.8 548.9 99.3 512zM448 320L560 320L560 296.6C560 292.4 558.3 288.3 555.3 285.3L514.7 244.7C511.7 241.7 507.6 240 503.4 240L448 240L448 320zM448 368L448 400.4C450.6 400.2 453.3 400 456 400C496.3 400 530.2 427.1 540.7 464L544 464C552.8 464 560 456.8 560 448L560 368L448 368zM184 528C206.1 528 224 510.1 224 488C224 465.9 206.1 448 184 448C161.9 448 144 465.9 144 488C144 510.1 161.9 528 184 528zM456 528C478.1 528 496 510.1 496 488C496 465.9 478.1 448 456 448C433.9 448 416 465.9 416 488C416 510.1 433.9 528 456 528z"/></svg> Free Delivery Over <strong>£' + (threshold / 100) + '</strong>'
      };
    }

    if (remaining > 0 && percent < ALMOST_THRESHOLD_PERCENT) {
      // State 2: early — single row, strong wraps amount only
      return {
        state: 'early',
        html: 'Add <strong>' + remainingFormatted + ' more</strong> for free delivery'
      };
    }

    if (remaining > 0) {
      // State 3: almost there — two lines, column layout via CSS data-state
      return {
        state: 'almost',
        html: '<strong>Almost there!</strong><span>Just ' + remainingFormatted + ' more for free delivery</span>'
      };
    }

    // State 4: unlocked
    return {
      state: 'unlocked',
      html: '<svg class="free-shipping-bar__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>Free delivery unlocked'
    };
  }

  // ─── Update all bars on the page ──────────────────────────────────────────
  function updateBars(cartTotal) {
    var bars = document.querySelectorAll('.free-shipping-bar');
    bars.forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
      if (!threshold) return;

      var textEl = bar.querySelector('.free-shipping-bar__text');
      if (!textEl) return;

      // The Delivery tab uses its own wording ("£X more for free standard delivery")
      // via data-copy-variant; every other bar keeps the default copy.
      if (bar.getAttribute('data-copy-variant') === 'delivery') {
        var remaining = threshold - cartTotal;
        if (remaining > 0) {
          textEl.innerHTML = '<strong>' + formatMoney(remaining) + ' more</strong> for free standard delivery';
          bar.setAttribute('data-state', 'early');
        } else {
          textEl.innerHTML = '<strong>Free standard delivery</strong> unlocked';
          bar.setAttribute('data-state', 'unlocked');
        }
      } else {
        var copy = getStateCopy(cartTotal, threshold);
        textEl.innerHTML = copy.html;
        bar.setAttribute('data-state', copy.state);
      }

      // Optional progress fill (only where a bar includes one, e.g. the Delivery tab).
      var fill = bar.querySelector('.free-shipping-bar__fill');
      if (fill) {
        var pct = Math.max(0, Math.min(100, (cartTotal / threshold) * 100));
        fill.style.width = pct + '%';
      }
    });
  }

  // ─── Fetch current cart total from Shopify Ajax API ───────────────────────
  function fetchCartAndUpdate() {
    fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateBars(cart.total_price);
      })
      .catch(function (err) {
        console.warn('[free-shipping-bar] Could not fetch cart:', err);
      });
  }

  // ─── Listen for cart changes ───────────────────────────────────────────────
  var cartEvents = [
    'cart:updated',
    'cart:refresh',
    'theme:cart:added',
    'cart-drawer:open',
  ];

  cartEvents.forEach(function (eventName) {
    document.addEventListener(eventName, fetchCartAndUpdate);
  });

  document.addEventListener('cart:item-added', fetchCartAndUpdate);

  // ─── Fallback: intercept fetch calls to /cart/add ────────────────────────
  (function () {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = args[0];
      var isCartAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;

      return originalFetch.apply(this, args).then(function (response) {
        if (isCartAdd && response.ok) {
          setTimeout(fetchCartAndUpdate, 300);
        }
        return response;
      });
    };
  })();

  // ─── Init on page load ────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCartAndUpdate);
  } else {
    fetchCartAndUpdate();
  }

})();
